import { pxToRem } from '../../utils';
var treeItemStyles = {
    root: function () { return ({
        listStyleType: 'none',
        padding: "0 0 0 " + pxToRem(1),
    }); },
};
export default treeItemStyles;
